module.exports = __webpack_public_path__ + "img/cozinha-xpto2.447a56bb.jpg";